<script setup lang="ts">
import { computed, ref, useI18n } from '#imports';
import { LanguageSelector, getBrowserLocale } from 'r3ui-lib';
import Cookies from 'js-cookie';

const { locale, locales, setLocale } = useI18n();
const savedLocale = Cookies.get('i18n_redirected');
const defaultLocale = savedLocale || getBrowserLocale();
const localeModel = ref(defaultLocale);

function setLocaleHandler(e: string) {
  if (e === locale.value) return false;
  setLocale(e as typeof locale.value);
  window.location.reload();
}

const localeOptions = computed(() => {
  return locales.value.map((localeInfo: { code: string; name?: string }) => ({
    id: localeInfo.code,
    label: localeInfo.name ?? localeInfo.code,
  }));
});
</script>

<template>
  <LanguageSelector
    v-model="localeModel"
    width="150px"
    :options="localeOptions"
    @update:model-value="setLocaleHandler"
  />
</template>
